<template>
  <div class="limit-box">
    <div class="tree-box treeScrollBar">
      <el-tree :data="treeData" show-checkbox default-expand-all node-key="id" ref="tree" :props="defaultProps">
      </el-tree>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  props: {
    setDisabledAttr: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
    return {
      monitorId: Number(Cookies.get("monitorId")),
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
    }
  },

  mounted() {
  },
  methods: {
    async initDataList(url) {
      let res = await this.$Http.get(url);
      if (res.success) {
        let list = res.result;
        if (this.setDisabledAttr) {
          this.setDisabled(list);
        }
        this.treeData = list;
        let checkedId = [];
        this._setCheckedIds(checkedId, list);
        this.$nextTick(() => {
          this.$refs.tree.setCheckedKeys(checkedId);
        });
      }
    },
    setDisabled(arr) {
      for (var i = 0; i < arr.length; i++) {
        arr[i]['disabled'] = true
        if (arr[i].children && arr[i].children.length > 0) {
          this.setDisabled(arr[i].children)
        }
      }
    },
    _setCheckedIds(checkedId, res) {
      res.forEach(e => {
        if (e.checked) {
          checkedId.push(e.id);
        }
        if (e.children != null && e.children.length > 0) {
          this._setCheckedIds(checkedId, e.children);
        }
      })
    },
    getCheckedData() {
      // let checkedKey = this.$refs.tree.getHalfCheckedKeys();
      let checkedKey = [];
      checkedKey.push(...this.$refs.tree.getCheckedKeys());
      checkedKey = checkedKey.filter(e => e != -1 && e != -2);
      return checkedKey;
    }
  }
}
</script>

<style scoped lang="scss">
.tree-box {
  height: 280px;
  overflow: auto;
}
</style>

<style lang="scss">
.limit-box {

  .el-tree-node.is-current {
    .el-tree-node__content {
      background-color: #fff;
    }
  }
}
</style>
